import React, { useEffect, useRef, useState, } from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
export const HEIGHT = 0;
export const WIDTH = 0;
const Hovered = (props) => {
    const [position, setPosition] = useState({});
    const [visible, setVisible] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const newPosition = {};
        const toolTipNode = ref.current?.getBoundingClientRect();
        const toolTipWidth = toolTipNode?.width;
        const toolTipHeight = toolTipNode?.height;
        const width = toolTipWidth ?? WIDTH;
        const height = toolTipHeight ?? HEIGHT;
        const parentNode = props.parentRef.current?.getBoundingClientRect();
        if (parentNode == null) {
            return;
        }
        const shouldShowOnTop = parentNode.y + parentNode.height + height >= window.innerHeight &&
            parentNode.y >= height;
        const shouldFloatLeft = parentNode.x + width >= window.innerWidth;
        newPosition.left = shouldFloatLeft
            ? `-${width - parentNode.width}px`
            : '0px';
        newPosition.top = shouldShowOnTop
            ? `-${height}px`
            : `${parentNode.height}px`;
        setPosition(newPosition);
        setVisible(true);
    }, [props.parentRef]);
    return (React.createElement(TooltipStyled, { visible: visible, ref: ref, style: { ...position, ...props.style } }, props.children));
};
export default Hovered;
const TooltipStyled = styled.div `
  transition: opacity 100ms ease-in-out;
  position: absolute;
  z-index: 1000;
  background-color: ${THEME.BACKGROUND};
  box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.03);
  width: max-content;
  opacity: ${(props) => (props.visible ? '1' : '0')};
  pointer-events: ${(props) => (props.visible ? 'unset' : 'none')};
`;
//# sourceMappingURL=Hovered.js.map